import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { KpiFavoritesService } from 'app/services/kpi-favorites.service';

/**
 * Star button saving the current KPI selection as a favorite, meant to sit next to the
 * KPI select it applies to.
 *
 * The selection itself is fed to KpiFavoritesService by the host component, which reports
 * its changes through syncSelection. Both this control and KpiFavoritesMenuComponent read
 * the same service instance, provided by their common host.
 */
@Component({
  selector: 'app-kpi-favorite-save',
  templateUrl: './kpi-favorite-save.component.html',
  styleUrls: ['./kpi-favorite-save.component.scss'],
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, TranslocoPipe],
})
export class KpiFavoriteSaveComponent {
  protected favoritesService = inject(KpiFavoritesService);

  /** the translation key matching the state the star is displayed in */
  get tooltipKey(): string {
    if (this.favoritesService.currentFavorite !== null) {
      return 'SELECTION_ALREADY_IN_FAVORITES';
    }

    return this.favoritesService.isSaveAvailable() ? 'SAVE_FAVORITE' : 'SELECT_KPIS_TO_SAVE_A_FAVORITE';
  }
}
